<template>
  <div class="">
    <Header />

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <div>
      <div
        v-if="loading"
        class="flex items-center justify-center"
        style="height: calc(100vh - 350px) !important"
      >
        <img src="@/assets/newd/loading.gif" alt="" />
      </div>
      <div v-else>
        <div class="min-h-[70.7vh]">
          <div
            class="container mx-auto max-w-[1200px] overflow-y-auto px-4 sm:px-6 xl:px-0"
          >
            <section
              id="UserProfile"
              v-if="profileInfo"
              class="w-full py-3 flex flex-col md:flex-row flex-wrap gap-10 md:items-start justify-center"
            >
              <!-- Profile Card -->

              <div
                class="bg-white/90 backdrop-blur-sm shadow-xl rounded-2xl p-6 text-center w-full lg:w-[320px] mt-6 border border-gray-100/50 hover:shadow-2xl transition-all duration-300"
              >
                <div class="flex flex-col items-center relative">
                  <div class="relative group">
                    <div v-if="profileInfo.data.profile == 'None'">
                      <div
                        class="w-28 h-28 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center text-4xl text-white font-bold shadow-lg"
                      >
                        {{ profileInfo.data.user.slice(0, 1).toUpperCase() }}
                      </div>
                    </div>
                    <div v-else class="relative">
                      <img
                        :src="profileInfo.data.profile"
                        alt="Profile Picture"
                        class="w-28 h-28 rounded-full object-cover border-4 border-white shadow-lg"
                      />
                      <div
                        class="absolute inset-0 rounded-full bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center"
                      >
                        <span class="text-white text-sm font-medium"
                          >Change</span
                        >
                      </div>
                    </div>

                    <button
                      @click="changeProfile = true"
                      class="absolute -bottom-2 -right-2 bg-blues hover:bg-hover text-white p-2 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 transform hover:scale-110"
                    >
                      <svg
                        class="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                        />
                      </svg>
                    </button>
                  </div>

                  <form
                    v-if="changeProfile"
                    @submit.prevent="imageHandles"
                    class="py-4 flex flex-col items-center justify-center gap-4 w-full bg-gray-50 rounded-xl p-4 mt-4"
                  >
                    <input
                      type="file"
                      name=""
                      id="image_uploads"
                      required
                       accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                  @change="validateImage"

                      class="w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                    />
                     <p class="text-[11px] text-gray-500">
                  Only <strong>JPG</strong>, <strong>JPEG</strong>  &
                  <strong>PNG</strong> files are allowed.
                </p>
                    <div class="flex items-center gap-3">
                      <button
                        type="submit"
                        class="bg-blues hover:bg-hover text-white px-4 py-2 rounded-lg text-sm font-medium shadow-md hover:shadow-lg transition-all"
                      >
                        Change Photo
                      </button>
                      <button
                        @click="changeProfile = false"
                        class="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg text-sm font-medium shadow-md hover:shadow-lg transition-all"
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>

                <div class="mt-6">
                  <h2 class="text-2xl font-bold text-gray-900 capitalize">
                    {{ profileInfo.data.user }}
                  </h2>
                </div>

                <div class="mt-8 pt-6 border-t border-gray-100">
                  <div class="flex justify-center gap-4">
                    <a
                      :href="profileInfo.data.linkedin"
                      target="_blank"
                      title="LinkedIn"
                      class="text-gray-400 hover:text-blue-600 transition-colors duration-200"
                    >
                      <svg
                        class="w-6 h-6"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>

              <!-- Personal Details Card -->
              <div
                class="w-full max-w-full md:max-w-[720px] flex flex-col gap-5 bg-white px-4 sm:px-6 md:py-10"
              >
                <div class="flex flex-wrap gap-2 border-b border-gray-200 pb-4">
                  <button
                    v-for="tab in tabs"
                    :key="tab"
                    @click="handleTabClick(tab)"
                    :class="[
                      'px-6 py-2.5 rounded-lg font-medium text-sm transition-all duration-200 capitalize',
                      active_tab == tab
                        ? 'bg-blues text-white shadow-lg shadow-blue-200'
                        : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900',
                    ]"
                  >
                    {{ tab }}
                  </button>
                </div>

                <div
                  v-if="active_tab == 'profile details'"
                  class="w-full flex flex-col gap-6"
                >
                  <div class="flex justify-between items-center">
                    <h3 class="text-xl font-bold text-gray-900">
                      Personal Details
                    </h3>
                  </div>

                  <div class="bg-gray-50 rounded-xl p-6">
                    <dl class="divide-y divide-gray-200">
                      <div class="py-3 flex flex-col sm:flex-row">
                        <dt class="text-sm font-medium text-gray-500 sm:w-1/3">
                          Full Name
                        </dt>
                        <dd class="text-sm text-gray-900 sm:w-2/3">
                          {{ profileInfo.data.user }}
                        </dd>
                      </div>
                      <div class="py-3 flex flex-col sm:flex-row">
                        <dt class="text-sm font-medium text-gray-500 sm:w-1/3">
                          Role
                        </dt>
                        <dd class="text-sm text-gray-900 sm:w-2/3">
                          {{
                            userInfo.user.permission
                              .split("_")[1]
                              .charAt(0)
                              .toUpperCase() +
                            userInfo.user.permission.split("_")[1].slice(1)
                          }}
                        </dd>
                      </div>
                      <div class="py-3 flex flex-col sm:flex-row">
                        <dt class="text-sm font-medium text-gray-500 sm:w-1/3">
                          Email
                        </dt>
                        <dd class="text-sm text-gray-900 sm:w-2/3">
                          {{ profileInfo.data.Email }}
                        </dd>
                      </div>
                      <div class="py-3 flex flex-col sm:flex-row">
                        <dt class="text-sm font-medium text-gray-500 sm:w-1/3">
                          Mobile
                        </dt>
                        <dd class="text-sm text-gray-900 sm:w-2/3">
                          {{ profileInfo.data.mobile || "Not provided" }}
                        </dd>
                      </div>
                      <div class="py-3 flex flex-col sm:flex-row">
                        <dt class="text-sm font-medium text-gray-500 sm:w-1/3">
                          Program
                        </dt>
                        <dd class="text-sm text-gray-900 sm:w-2/3">
                          {{ profileInfo.data.program || "None" }}
                        </dd>
                      </div>
                      <div class="py-3 flex flex-col sm:flex-row">
                        <dt class="text-sm font-medium text-gray-500 sm:w-1/3">
                          Address
                        </dt>
                        <dd class="text-sm text-gray-900 sm:w-2/3">
                          {{ profileInfo.data.address || "Not provided" }}
                        </dd>
                      </div>
                      <div class="py-3 flex flex-col sm:flex-row">
                        <dt class="text-sm font-medium text-gray-500 sm:w-1/3">
                          State
                        </dt>
                        <dd class="text-sm text-gray-900 sm:w-2/3">
                          {{ cleanValue(profileInfo.data.state) || "Not provided" }}
                        </dd>
                      </div>
                      <div class="py-3 flex flex-col sm:flex-row">
                        <dt class="text-sm font-medium text-gray-500 sm:w-1/3">
                          City
                        </dt>
                        <dd class="text-sm text-gray-900 sm:w-2/3">
                          {{ cleanValue(profileInfo.data.city) || "Not provided" }}
                        </dd>
                      </div>
                      <div class="py-3 flex flex-col sm:flex-row">
                        <dt class="text-sm font-medium text-gray-500 sm:w-1/3">
                          Description
                        </dt>
                        <dd class="text-sm text-gray-900 sm:w-2/3">
                          <p class="leading-relaxed">
                            {{
                              profileInfo.data.description?.slice(0, 180) ||
                              "None"
                            }}
                            <button
                              v-if="profileInfo.data.description?.length > 180"
                              class="text-blue-600 hover:text-blue-700 font-medium ml-1"
                            >
                              ...Read More
                            </button>
                          </p>
                        </dd>
                      </div>
                    </dl>
                  </div>
                  <div class="mt-4 flex flex-wrap justify-center gap-3">
                    <div class="flex flex-wrap gap-4">
                      <button
                        @click="ProfileEdit"
                        class="px-6 py-2.5 bg-blues hover:bg-hover text-white text-sm font-medium rounded-lg shadow-md hover:shadow-lg transition-all duration-200 flex items-center gap-2"
                      >
                        <svg
                          class="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                          />
                        </svg>
                        Edit
                      </button>

                      <button
                        @click="ChangePasswordPopup"
                        class="px-6 py-2.5 bg-blues hover:bg-hover text-white text-sm font-medium rounded-lg shadow-md hover:shadow-lg transition-all duration-200 flex items-center gap-2"
                      >
                        <svg
                          class="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M15 7a4 4 0 11-8 0 4 4 0 018 0zM3 21v-2a4 4 0 014-4h4a4 4 0 014 4v2"
                          />
                        </svg>
                        Change Password
                      </button>
                    </div>

                    <!-- <router-link
                  class="flex items-center gap-2 px-4 py-2 text-white bg-[#0085DB] rounded-lg"
                >
                  <img
                    src="@/assets/newd/changee.png"
                    alt="Change Icon"
                    class="w-5 h-5"
                  />
                  <span class="text-sm font-medium">Change Password</span>
                </router-link> -->
                  </div>
                </div>
                <div v-if="active_tab == 'accessible course'" class="">
                  <div class="flex justify-between items-center">
                    <h3 class="text-xl font-bold text-gray-900">
                      Courses
                      <span class="ml-2 text-sm font-normal text-gray-500">
                        ({{ course_count || 0 }})
                      </span>
                    </h3>

                    <div class="flex items-center gap-2">
                      <div class="relative md:w-80">
                        <div
                          class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-4 w-4 text-gray-400"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                            />
                          </svg>
                        </div>
                        <input
                          type="text"
                          v-model="searching"
                          @input="getCourses(1)"
                          placeholder="Search..."
                          class="w-full rounded-xl border border-gray-200 bg-white pl-10 pr-10 py-1.5 text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                        />
                        <button
                          v-if="searching"
                          @click="clearSearch"
                          class="absolute inset-y-0 right-0 pr-3 flex items-center"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-4 w-4 text-gray-400 hover:text-gray-600"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M6 18L18 6M6 6l12 12"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    class="w-full flex flex-col gap-5 py-5"
                    v-if="course_list.length > 0"
                  >
                    <div
                      class="w-full bg-white rounded-2xl shadow-sm border border-slate-200 overflow-x-auto"
                    >
                      <table class="min-w-full">
                        <thead>
                          <tr
                            class="text-left bg-gray-100 text-textblues whitespace-nowrap text-sm capitalize"
                          >
                            <th class="px-4 py-3 border-b border-r">S.No</th>
                            <th class="px-4 py-3 border-b border-r">
                              Course Title
                            </th>
                            <th class="px-4 py-3 border-b border-r hidden">
                              description
                            </th>
                            <th class="px-4 py-3 border-b border-r">
                              Course Code
                            </th>
                            <th class="px-4 py-3 border-b border-r hidden">
                              Section
                            </th>
                            <th class="px-4 py-3 border-b border-r">
                              created at
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(course, index) in course_list"
                            :key="course.id"
                            class="border-b pb-3 w-full cursor-pointer hover:bg-gray-100 text-sm"
                          >
                            <td
                              class="px-4 py-3 border-b border-r text-gray-500"
                            >
                              {{ (current_page - 1) * pageSize + (index + 1) }}
                            </td>
                            <td
                              class="px-4 py-3 border-b border-r text-gray-800"
                            >
                              {{ course.title }}
                            </td>
                            <td class="px-4 py-3 border-b border-r hidden">
                              {{ course.short_description }}
                            </td>
                            <td
                              class="px-4 py-3 border-b border-r text-gray-500 text-xs"
                            >
                              {{ course.course_code }}
                            </td>
                            <td
                              class="px-4 py-3 border-b border-r text-gray-500 hidden"
                            >
                              {{ course.class_section }}
                            </td>
                            <td
                              class="px-4 py-3 border-b border-r text-gray-500 text-xs"
                            >
                              {{ formatDate(course.updated_at) }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div
                      class="flex flex-col sm:flex-row justify-center gap-3 mt-4 relative"
                    >
                      <!-- PAGE SIZE -->
                      <div
                        class="md:absolute md:left-3 md:top-4 gap-2 text-sm text-gray-600 flex justify-center items-center md:flex-none md:justify-normal"
                      >
                        <span class="flex md:hidden">Rows per page:</span>
                        <select
                          v-model="pageSize"
                          @change="onPageSizeChange"
                          class="border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        >
                          <option :value="10">10</option>
                          <option :value="20">20</option>
                          <option :value="50">50</option>
                          <option :value="100">100</option>
                        </select>
                      </div>

                      <!-- PAGINATION -->
                      <div v-if="totalPages > 1" class="flex justify-center">
                        <Pagination
                          :totalPages="totalPages"
                          ref="paginationRef"
                          @page-changed="getCourses"
                        />
                      </div>
                    </div>
                    <!-- <Pagination
                  :totalPages="totalPages"
                  ref="paginationRef"
                  @page-changed="this.getCourses"
                /> -->
                  </div>
                  <div v-else>
                    <div
                      class="flex flex-col items-center justify-center gap-4 py-16 px-4"
                    >
                      <div class="bg-gray-50 rounded-full p-6">
                        <svg
                          class="w-16 h-16 text-gray-300"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                          />
                        </svg>
                      </div>
                      <div class="text-center">
                        <h3 class="text-gray-600 text-lg font-semibold mb-1">
                          No courses available
                        </h3>
                        <p class="text-gray-400 text-sm">
                          Get started by creating a new course
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="active_tab === 'meeting settings'"
                  class="w-full max-w-4xl mx-auto space-y-6"
                >
                  <div
                    class="flex flex-wrap gap-2 justify-between items-end mb-2"
                  >
                    <div>
                      <h2 class="text-2xl font-bold text-gray-900">
                        Meeting Settings
                      </h2>
                      <p class="text-sm text-gray-500">
                        Configure your providers and manage meeting
                        integrations.
                      </p>
                    </div>
                    <button
                      @click="showCreateModal = true"
                      class="flex items-center gap-2 px-5 py-2.5 bg-blues hover:bg-hover text-white text-sm font-bold rounded-xl shadow-lg shadow-blue-200 transition-all active:scale-95"
                    >
                      <svg
                        class="w-5 h-5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2.5"
                          d="M12 4v16m8-8H4"
                        />
                      </svg>
                      New Meeting
                    </button>
                  </div>

                  <div
                    v-if="providers.length"
                    class="bg-white border border-gray-200 shadow-sm rounded-2xl overflow-hidden"
                  >
                    <!-- Header -->
                    <div
                      class="px-6 py-5 border-b border-gray-100 flex justify-between items-center bg-gray-50/50"
                    >
                      <span
                        class="text-[11px] font-black text-gray-400 uppercase tracking-[0.2em]"
                      >
                        System Configuration
                      </span>
                      <span
                        @click="toggleActive"
                        :class="[
                          'px-3 py-1 rounded-full text-xs font-bold border flex items-center gap-1.5 cursor-pointer transition-all duration-200',
                          isActive
                            ? 'bg-emerald-50 text-emerald-700 border-emerald-100 hover:bg-emerald-100 hover:text-emerald-800'
                            : 'bg-rose-50 text-rose-700 border-rose-100 hover:bg-rose-100 hover:text-rose-800',
                        ]"
                      >
                        <span
                          :class="[
                            'w-1.5 h-1.5 rounded-full transition-colors duration-200',
                            isActive ? 'bg-emerald-500' : 'bg-rose-500',
                          ]"
                        ></span>

                        {{ isActive ? "Active" : "Deactive" }}
                      </span>
                    </div>

                    <div class="p-8 space-y-8">
                      <!-- Provider Selection -->
                      <div>
                        <label
                          class="text-[11px] font-bold text-gray-400 uppercase tracking-widest mb-4 block"
                        >
                          Select Provider
                        </label>
                        <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
                          <label
                            v-for="provider in providers"
                            :key="provider.title"
                            class="cursor-pointer"
                          >
                            <input
                              type="radio"
                              v-model="selectedProvider"
                              :value="provider.title"
                              class="sr-only"
                            />
                            <div
                              :class="[
                                'flex flex-col items-center justify-center p-5 border-2 rounded-xl text-center transition-all duration-200',
                                selectedProvider === provider.title
                                  ? 'border-blue-500 bg-blue-50 ring-2 ring-blue-500/20'
                                  : 'border-gray-200 hover:border-gray-300',
                              ]"
                            >
                              <div class="flex items-center gap-3">
                                <!-- ICON WRAPPER -->
                                <div
                                  :class="[
                                    'p-2.5 rounded-lg shadow-md transition-colors',
                                    selectedProvider === provider.title
                                      ? provider.title === 'Teams'
                                        ? 'bg-purple-600'
                                        : provider.title === 'Zoom'
                                        ? 'bg-blues'
                                        : 'bg-green-600'
                                      : 'bg-gray-300',
                                  ]"
                                >
                                  <!-- ICONS -->
                                  <svg
                                    v-if="provider.title === 'Teams'"
                                    class="w-5 h-5 text-white"
                                    viewBox="0 0 24 24"
                                    fill="currentColor"
                                  >
                                    <path
                                      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"
                                    />
                                  </svg>
                                  <svg
                                    v-else-if="provider.title === 'Zoom'"
                                    class="w-5 h-5 text-white"
                                    viewBox="0 0 24 24"
                                    fill="currentColor"
                                  >
                                    <path
                                      d="M15 8l4.5-4.5v17l-4.5-4.5V8zM2 16V8c0-1.1.9-2 2-2h9c1.1 0 2 .9 2 2v8c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2z"
                                    />
                                  </svg>
                                  <svg
                                    v-else
                                    class="w-5 h-5 text-white"
                                    viewBox="0 0 24 24"
                                    fill="currentColor"
                                  >
                                    <path d="M12 4l8 4v8l-8 4-8-4V8l8-4z" />
                                  </svg>
                                </div>
                                <!-- TITLE -->
                                <span
                                  :class="[
                                    'font-bold transition-colors',
                                    selectedProvider === provider.title
                                      ? 'text-blue-700'
                                      : 'text-gray-700',
                                  ]"
                                >
                                  {{ provider.title }}
                                </span>
                              </div>
                            </div>
                          </label>
                        </div>
                      </div>

                      <!-- Dynamic Keys -->
                      <div
                        v-if="selectedProviderData"
                        class="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8 bg-gray-50/50 p-6 rounded-2xl border border-gray-100"
                      >
                        <div
                          v-for="(val, key) in selectedProviderData.value"
                          :key="key"
                          class="space-y-2"
                        >
                          <label
                            class="text-[10px] font-black text-gray-400 uppercase tracking-widest"
                          >
                            {{ key.replace("_", " ") }}
                          </label>
                          <input
                            v-if="isEditing"
                            type="text"
                            v-model="selectedProviderData.value[key]"
                            class="w-full bg-white border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none"
                          />
                          <p
                            v-else
                            class="text-sm font-mono bg-white border border-gray-200 px-3 py-2 rounded-lg text-gray-600 shadow-sm truncate"
                          >
                            {{ val }}
                          </p>
                        </div>
                      </div>

                      <!-- Buttons -->
                      <div class="flex justify-end gap-3">
                        <button
                          @click="isEditing = !isEditing"
                          class="px-4 py-1.5 text-sm font-bold rounded-xl transition-all border"
                          :class="
                            isEditing
                              ? 'bg-white border-gray-300 text-gray-700 hover:bg-gray-50'
                              : 'bg-gray-100 border-transparent text-gray-700 hover:bg-gray-200'
                          "
                        >
                          {{ isEditing ? "Cancel" : "Edit" }}
                        </button>
                        <button
                          v-if="!isEditing"
                          @click="showDeleteModal = true"
                          class="px-6 py-2.5 text-sm font-bold bg-rose-600 text-white rounded-xl hover:bg-rose-700 shadow-lg shadow-rose-100 transition-all"
                        >
                          Delete
                        </button>
                        <button
                          v-if="isEditing"
                          @click="saveSettings"
                          class="px-6 py-2.5 text-sm font-bold bg-emerald-600 text-white rounded-xl hover:bg-emerald-700 shadow-lg shadow-emerald-100 transition-all"
                        >
                          Update
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="active_tab === 'Automation'" class="w-full">
                  <div class="flex justify-between items-center mb-4">
                    <h3 class="text-xl font-bold text-gray-900">
                      Email Automation
                      <span class="ml-2 text-sm font-normal text-gray-500">
                        ({{ mylist_count || 0 }})
                      </span>
                    </h3>
                    <div class="flex items-center gap-2">
                      <div class="relative md:w-80">
                        <div
                          class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-4 w-4 text-gray-400"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                            />
                          </svg>
                        </div>
                        <input
                          type="text"
                          v-model="mylist_searching"
                          @input="mylist(1)"
                          placeholder="Search..."
                          class="w-full rounded-xl border border-gray-200 bg-white pl-10 pr-10 py-1.5 text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                        />
                        <button
                          v-if="mylist_searching"
                          @click="clearMylistSearch"
                          class="absolute inset-y-0 right-0 pr-3 flex items-center"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-4 w-4 text-gray-400 hover:text-gray-600"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M6 18L18 6M6 6l12 12"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div v-if="mylist_data.length > 0" class="">
                    <div
                      class="overflow-x-auto bg-white rounded-2xl shadow-sm border border-slate-200"
                    >
                      <table class="min-w-full text-sm">
                        <thead>
                          <tr class="bg-gray-100 text-textblues text-left">
                            <th class="px-6 py-3 border-b border-r">S.No</th>
                            <th class="px-6 py-3 border-b border-r">
                              Send Email List
                            </th>
                            <th class="px-6 py-3 border-b border-r">
                              Push Enabled
                            </th>
                            <th class="px-6 py-3 border-b border-r">Preview</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in mylist_data"
                            :key="item.id"
                            class="border-b hover:bg-gray-50 transition-colors"
                          >
                            <td
                              class="px-6 py-3 border-b border-r text-gray-600"
                            >
                              {{
                                (mylist_current_page - 1) * mylist_pageSize +
                                (index + 1)
                              }}
                            </td>
                            <td
                              class="px-6 py-3 border-b border-r font-medium text-gray-800 capitalize"
                            >
                              {{ item.code.replace(/_/g, " ").toLowerCase() }}
                            </td>
                            <td class="px-6 py-3 border-b border-r">
                              <button
                                @click="askToggleConfirm(item)"
                                :class="[
                                  'relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200',
                                  item.push_enabled
                                    ? 'bg-emerald-500'
                                    : 'bg-gray-300',
                                ]"
                              >
                                <span
                                  :class="[
                                    'inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform duration-200',
                                    item.push_enabled
                                      ? 'translate-x-6'
                                      : 'translate-x-1',
                                  ]"
                                ></span>
                              </button>
                            </td>
                            <td class="px-6 py-3 border-b border-r">
                              <button
                                @click="openPreviewModal(item)"
                                class="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium transition-all"
                                style="
                                  color: #085041;
                                  border-top: none;
                                  border-right: none;
                                  border-bottom: none;
                                "
                                onmouseover="this.style.color='#5DCAA5'"
                                onmouseout="this.style.color='#085041'"
                              >
                                <svg
                                  class="w-4 h-4"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="1.8"
                                    d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                                  />
                                  <circle cx="12" cy="12" r="3" />
                                </svg>
                                Preview
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div
                      class="flex flex-col sm:flex-row justify-center gap-3 mb-4 relative"
                    >
                      <!-- PAGE SIZE -->
                      <div
                        class="md:absolute md:left-3 md:top-4 gap-2 text-sm text-gray-600 flex justify-center items-center md:flex-none md:justify-normal"
                      >
                        <span class="flex md:hidden">Rows per page:</span>
                        <select
                          v-model="mylist_pageSize"
                          @change="onMylistPageSizeChange"
                          class="border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        >
                          <option :value="10">10</option>
                          <option :value="20">20</option>
                          <option :value="50">50</option>
                          <option :value="100">100</option>
                        </select>
                      </div>

                      <!-- PAGINATION -->
                      <div
                        v-if="mylist_totalPages > 1"
                        class="flex justify-center"
                      >
                        <Pagination
                          :totalPages="mylist_totalPages"
                          @page-changed="mylist"
                        />
                      </div>
                    </div>
                    <!-- <div class="px-4 py-3">
                  <Pagination
                    :totalPages="mylist_totalPages"
                    @page-changed="mylist"
                  />
                </div> -->
                  </div>

                  <div v-else>
                    <div
                      class="flex flex-col items-center justify-center gap-4 py-16 px-4"
                    >
                      <div class="bg-gray-50 rounded-full p-6">
                        <svg
                          class="w-16 h-16 text-gray-300"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                          />
                        </svg>
                      </div>
                      <div class="text-center">
                        <h3 class="text-gray-600 text-lg font-semibold mb-1">
                          No notification settings available
                        </h3>
                      </div>
                    </div>
                  </div>
                  <!-- Toggle Confirm Popup -->
                  <div
                    v-if="showToggleConfirm && pendingToggleItem"
                    class="fixed inset-0 z-50 flex items-center justify-center p-4"
                  >
                    <!-- Backdrop -->
                    <div
                      class="fixed inset-0 bg-black/60"
                      @click="cancelToggle"
                    ></div>

                    <!-- Modal -->
                    <div
                      class="relative bg-white rounded-2xl shadow-2xl w-full max-w-md z-10 overflow-hidden"
                    >
                      <!-- Close Button -->
                      <button
                        @click="cancelToggle"
                        class="absolute top-3 right-3 bg-red-500 hover:bg-red-600 text-white w-8 h-8 rounded-md flex items-center justify-center transition-all"
                      >
                        <svg
                          class="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2.5"
                            d="M6 18L18 6M6 6l12 12"
                          />
                        </svg>
                      </button>

                      <!-- Body -->
                      <div
                        class="px-10 py-12 flex flex-col items-center text-center"
                      >
                        <p class="text-gray-700 text-lg font-medium mb-3">
                          Are you sure want to
                          {{
                            pendingToggleItem.push_enabled
                              ? "disable"
                              : "enable"
                          }}
                          ?
                        </p>
                        <p class="text-textblues text-xl font-bold capitalize">
                          {{
                            pendingToggleItem.code
                              .replace(/_/g, " ")
                              .toLowerCase()
                          }}
                        </p>
                      </div>

                      <!-- Footer -->
                      <div
                        class="bg-gray-100 px-8 py-5 flex items-center justify-between gap-4"
                      >
                        <button
                          @click="cancelToggle"
                          class="px-5 py-2.5 bg-white border border-gray-300 text-gray-700 font-semibold rounded-lg hover:bg-gray-50 transition-all shadow-sm"
                        >
                          Cancel
                        </button>
                        <button
                          @click="confirmToggle"
                          class="px-10 py-2.5 text-white font-semibold rounded-lg transition-all shadow-sm"
                          :class="
                            pendingToggleItem.push_enabled
                              ? 'bg-blue-500 hover:bg-hover'
                              : 'bg-blue-500 hover:bg-hover'
                          "
                        >
                          Yes
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="flex flex-col gap-5 w-[500px]">
            <div class="flex items-center gap-5">
              <img src="@/assets/newd/lg1.png" alt="" />
              <p>
                <span class="font-semibold text-base"
                  >Total Students:
                  <span class="font-semibold text-textblues">56</span></span
                >
              </p>
            </div>

            <div class="flex items-center gap-5">
              <img src="@/assets/newd/lg2.png" alt="" />
              <p>
                <span class="font-semibold text-base"
                  >Active Courses:
                  <span class="font-semibold text-textblues">56</span></span
                >
              </p>
            </div>

            <div class="flex items-center gap-5">
              <img src="@/assets/newd/lg3.png" alt="" />
              <p>
                <span class="font-semibold text-base"
                  >Total Review:
                  <span class="font-semibold text-textblues">56</span></span
                >
              </p>
            </div>
          </div> -->
              </div>
            </section>
          </div>

          <!-- meeting -->

          <div
            v-if="showCreateModal"
            class="fixed w-full min-h-screen bg-black bg-opacity-75 top-0 z-50 flex justify-center items-center"
          >
            <div
              class="bg-white rounded-3xl shadow-2xl w-full max-w-md overflow-hidden animate-in fade-in zoom-in duration-200"
            >
              <div
                class="px-8 py-6 border-b border-gray-100 flex justify-between items-center"
              >
                <h3 class="text-xl font-bold text-textblues">New Meeting</h3>
                <button
                  @click="showCreateModal = false"
                  class="p-2 hover:bg-gray-100 rounded-full transition-colors"
                >
                  <svg
                    class="w-5 h-5 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>

              <form @submit.prevent="submitMeeting" class="p-8 space-y-6">
                <!-- Meeting Platform -->
                <div class="space-y-1.5">
                  <label class="block text-sm font-medium text-[#333333]">
                    Meeting Platform
                  </label>

                  <div class="relative">
                    <select
                      v-model="newMeeting.title"
                      required
                      class="w-full appearance-none border border-gray-200 rounded-xl px-4 py-3 pr-10 text-sm font-medium bg-white focus:ring-4 focus:ring-blue-500/10 focus:border-blue-500 outline-none"
                    >
                      <option disabled value="">Select Platform</option>
                      <option value="Teams">Microsoft Teams</option>
                      <option value="Zoom">Zoom</option>
                    </select>
                  </div>
                </div>

                <!-- 🔵 TEAMS -->
                <template v-if="newMeeting.title === 'Teams'">
                  <div class="space-y-1.5">
                    <label class="block text-sm font-medium text-[#333333]">
                      Access Key
                    </label>
                    <input
                      v-model="newMeeting.access_key"
                      required
                      type="text"
                      placeholder="Enter Teams access key"
                      class="w-full border border-gray-200 rounded-xl px-4 py-3"
                    />
                  </div>

                  <div class="space-y-1.5">
                    <label class="block text-sm font-medium text-[#333333]">
                      Secret Key
                    </label>
                    <input
                      v-model="newMeeting.secret_key"
                      required
                      type="text"
                      placeholder="Enter Teams secret key"
                      class="w-full border border-gray-200 rounded-xl px-4 py-3"
                    />
                  </div>
                  <label class="flex items-center gap-3 cursor-pointer">
                    <input
                      type="checkbox"
                      v-model="newMeeting.teams_published"
                      class="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                    />
                    <span class="text-sm font-semibold text-gray-700">
                      Publish Teams Meeting
                    </span>
                  </label>
                </template>

                <!-- 🟢 ZOOM -->
                <template v-if="newMeeting.title === 'Zoom'">
                  <div class="space-y-4">
                    <!-- Zoom Client ID -->
                    <div class="space-y-1">
                      <label class="block text-sm font-medium text-gray-700">
                        Zoom Client ID
                      </label>
                      <input
                        v-model="newMeeting.zoom_client_id"
                        type="text"
                        required
                        placeholder="Enter Zoom Client ID"
                        class="w-full border border-gray-200 rounded-xl px-4 py-2.5"
                      />
                    </div>

                    <!-- Zoom Client Secret -->
                    <div class="space-y-1">
                      <label class="block text-sm font-medium text-gray-700">
                        Zoom Client Secret
                      </label>
                      <input
                        v-model="newMeeting.zoom_client_secret"
                        type="password"
                        required
                        placeholder="Enter Zoom Client Secret"
                        class="w-full border border-gray-200 rounded-xl px-4 py-2.5"
                      />
                    </div>

                    <!-- Zoom Account ID -->
                    <div class="space-y-1">
                      <label class="block text-sm font-medium text-gray-700">
                        Zoom Account ID
                      </label>
                      <input
                        v-model="newMeeting.zoom_account_id"
                        type="text"
                        required
                        placeholder="Enter Zoom Account ID"
                        class="w-full border border-gray-200 rounded-xl px-4 py-2.5"
                      />
                    </div>

                    <!-- Publish -->
                    <label class="flex items-center gap-3 pt-1 cursor-pointer">
                      <input
                        type="checkbox"
                        v-model="newMeeting.zoom_published"
                        class="w-5 h-5 text-green-600 border-gray-300 rounded"
                      />
                      <span class="text-sm font-semibold text-gray-700">
                        Publish Zoom Meeting
                      </span>
                    </label>
                  </div>
                </template>

                <!-- Buttons -->
                <div class="flex gap-4 pt-2">
                  <!-- Cancel Button -->
                  <button
                    type="button"
                    @click="showCreateModal = false"
                    class="flex-1 px-4 py-2 border border-gray-200 text-gray-600 font-bold rounded-xl hover:bg-gray-100 hover:text-gray-800 hover:border-gray-300 transition-all duration-200"
                  >
                    Cancel
                  </button>

                  <!-- Save Button -->
                  <button
                    type="submit"
                    class="flex-1 px-4 py-2 bg-blues text-white font-bold rounded-xl hover:bg-hover hover:shadow-lg hover:shadow-blue-300/40 transition-all duration-200 active:scale-95"
                  >
                    Save Meeting
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div
            v-if="showDeleteModal"
            class="fixed inset-0 z-50 flex items-center justify-center p-4 overflow-x-hidden overflow-y-auto"
          >
            <div
              class="fixed inset-0 bg-gray-900/60"
              @click="cancelDelete"
            ></div>

            <div
              class="relative bg-white rounded-2xl shadow-2xl max-w-sm w-full p-8 border border-gray-100"
            >
              <div class="flex flex-col items-center text-center">
                <div
                  class="w-16 h-16 bg-rose-50 rounded-full flex items-center justify-center mb-4"
                >
                  <svg
                    class="w-8 h-8 text-rose-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                    />
                  </svg>
                </div>

                <h3 class="text-xl font-bold text-gray-900 mb-2">
                  Are you sure?
                </h3>
                <p class="text-gray-500 text-sm mb-8 leading-relaxed">
                  This action cannot be undone. This will permanently delete the
                  <strong>{{ selectedProvider }}</strong> configuration.
                </p>

                <div class="flex flex-col w-full gap-3">
                  <button
                    @click="confirmDelete"
                    class="w-full py-3 bg-rose-600 text-white rounded-xl font-bold hover:bg-rose-700"
                  >
                    Yes
                  </button>
                  <button
                    @click="showDeleteModal = false"
                    class="w-full py-3 bg-gray-100 text-gray-700 rounded-xl font-bold hover:bg-gray-200"
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="mt-10 flex flex-col gap-10">
      <div class="flex items-center justify-center gap-10">
        <div class="flex items-center gap-2" @click="activeMenu = 'course'">
          <p
            class="text-base p-2 font-bold cursor-pointer"
            :class="{
              'border-b-2 border-blues text-textblues': activeMenu == 'course',
            }"
          >
            Courses
          </p>
        </div>
        <div class="flex items-center gap-2" @click="activeMenu = 'mail'">
          <p
            class="text-base p-2 font-bold cursor-pointer"
            :class="{
              'border-b-2 border-blues text-textblues': activeMenu == 'mail',
            }"
          >
            Send Mail
          </p>
        </div>
      </div>

      <div class="container mx-auto max-w-[1200px] pb-20">
        <form v-if="activeMenu == 'course'"
          ref="createTeamRef"
          @submit.prevent="invitepost"
          class="flex flex-col gap-4 text-xs md:text-sm lg:text-base h-full"
        >
          <div class="flex flex-col gap-3 w-full">
            <label for="category" class="flex gap-2 items-center">
              <div>
                Course list
                <span class="text-red-400">*</span>
              </div>
            </label>
            <select
              name="course"
              class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
              id="course"
              required
            >
              <option value="" disabled selected>Select course</option>
              <option
                v-for="course in courselist"
                :key="course"
                :value="course.title"
              >
                <span> {{ course.title }}</span>
              </option>
            </select>
          </div>

          

          <div class="flex flex-col gap-3 w-full">
            <label for="studentmail" class="flex gap-2 items-center">
              <div>Student list <span class="text-red-400">*</span></div>
            </label>

            <input
              type="text"
              id="studentmail"
              v-model="searchQuery"
              @input="Studentsearch"
              placeholder="Search email"
              class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
            />
            <ul
              v-if="showdetail == false && this.studentlist.length > 0"
              class="bg-white w-full border rounded-lg shadow-md h-[150px] overflow-y-auto mt-1"
            >
              <li
                v-for="student in studentlist.slice(0, lengthCount)"
                :key="student.email"
                class="p-2 cursor-pointer hover:bg-gray-100"
                @click="selectStudent(student.email)"
              >
                {{ student.email }}
              </li>
            </ul>
          </div>

          <div class="flex justify-center pb-4 mt-3 gap-10">
            <button
              @click="closepopup"
              class="border text-gray-500 rounded-lg text-sm px-10 font-semibold py-2"
            >
              Close
            </button>
            <div class="flex gap-3 items-center">
              <button
                :disabled="disableStatus"
                :class="{
                  'cursor-not-allowed bg-gray-200 text-black':
                    disableStatus === true,
                  'cursor-pointer bg-blues text-white ':
                    disableStatus === false,
                }"
                type="submit"
                class="rounded-lg text-sm px-10 font-semibold py-2"
              >
                Invite
              </button>
              <div v-if="loaders" class="spinner"></div>
            </div>
          </div>
          <div
            v-if="invite_messages"
            class="text-green-500 font-bold text-left px-2 py-2 rounded-lg"
          >
            {{ invite_messages }}
          </div>
          <div
            v-if="invite_err_messages"
            class="text-red-500 font-bold text-left px-2 py-2 rounded-lg"
          >
            {{ invite_err_messages }}
          </div>
        </form>

        <form v-if="activeMenu == 'mail'"
          ref="mailref"
          @submit.prevent="sendmail"
          class="flex flex-col gap-4 text-xs md:text-sm lg:text-base h-full"
        >
          

          <div
            class="flex flex-col gap-2 w-full text-xs md:text-sm lg:text-base"
          >
            <div class="w-full flex flex-col gap-2">
              <input
                id="subject"
                placeholder="Subject"
                type="text"
                class="border rounded outline-none text-xs md:text-sm lg:text-base py-2 px-2"
                required
              />
            </div>
          </div>
          
          <div class="flex flex-col gap-2 w-full mt-2">
           
            <textarea
              textarea
              rows="12"
              cols="10"
              id="content"
              class="border border-gray-200 outline-none h-full w-full p-2 rounded"
              placeholder="Your message"
            ></textarea>
          </div>

          <div class="flex justify-start mt-4">
            <button
              type="submit"
              class="bg-blues px-8 py-2 text-sm text-white rounded-xl"
            >
              Send
            </button>
          </div>
        </form>

      </div>
    </div> -->

          <!-- PopUp -->
          <div
            v-if="popUp && updateDetails != null"
            class="fixed inset-0 z-50 overflow-y-auto"
            role="dialog"
            aria-modal="true"
          >
            <div
              class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
            >
              <div
                class="fixed inset-0 bg-gray-900/75 transition-opacity"
                aria-hidden="true"
                @click="popUp = false"
              ></div>

              <span
                class="hidden sm:inline-block sm:align-middle sm:h-screen"
                aria-hidden="true"
                >&#8203;</span
              >

              <div
                class="inline-block align-bottom bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
              >
                <div class="bg-white px-6 py-5 border-b border-gray-100">
                  <div class="flex justify-between items-center">
                    <h3 class="text-xl font-bold text-blue-600">
                      Edit Details
                    </h3>
                    <button
                      @click="popUp = false"
                      class="text-gray-400 hover:text-gray-500 focus:outline-none"
                    >
                      <svg
                        class="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>
                </div>

                <form
                  @submit.prevent="SubmitProfile"
                  class="px-6 py-5 space-y-4"
                >
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">
                      Mobile
                    </label>
                    <input
                      type="tel"
                      v-model="updateDetails.mobile"
                      placeholder="Mobile number"
                      class="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm bg-gray-50 focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none"
                      readonly
                    />
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">
                      Address
                    </label>
                    <input
                      type="text"
                      v-model="updateDetails.address"
                      class="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none"
                      placeholder="Enter your address"
                    />
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">
                      State
                    </label>
                    <input
                      v-model.trim="updateDetails.state"
                      type="text"
                      class="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm bg-white focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none"
                      placeholder="Enter your state"
                    />
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">
                      City
                    </label>
                    <input
                      v-model.trim="updateDetails.city"
                      type="text"
                      class="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm bg-white focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none"
                      placeholder="Enter your city"
                    />
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">
                      Description
                    </label>
                    <textarea
                      v-model="updateDetails.description"
                      rows="4"
                      class="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none resize-none"
                      placeholder="Write a short description about yourself"
                    ></textarea>
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">
                      LinkedIn Profile
                    </label>
                    <input
                      type="url"
                      v-model="updateDetails.linkedin"
                      class="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none"
                      placeholder="https://linkedin.com/in/username"
                    />
                  </div>

                  <div class="flex justify-center pt-5">
                    <button
                      type="submit"
                      class="w-full max-w-[200px] px-6 py-2.5 bg-blues text-white text-sm font-medium rounded-lg hover:bg-hover shadow-md hover:shadow-lg transition-all"
                    >
                      Save Changes
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div
            v-if="changePassword"
            class="fixed inset-0 z-50 overflow-y-auto"
            role="dialog"
            aria-modal="true"
          >
            <div
              class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
            >
              <div
                class="fixed inset-0 bg-gray-900/75 transition-opacity"
                aria-hidden="true"
                @click="changePassword = false"
              ></div>

              <span
                class="hidden sm:inline-block sm:align-middle sm:h-screen"
                aria-hidden="true"
                >&#8203;</span
              >

              <div
                class="inline-block align-bottom bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full"
              >
                <div class="bg-white px-6 py-5 border-b border-gray-100">
                  <div class="flex justify-between items-center">
                    <h3 class="text-xl font-bold text-blue-600">
                      Change Password
                    </h3>
                    <button
                      @click="changePassword = false"
                      class="text-gray-400 hover:text-gray-500 focus:outline-none"
                    >
                      <svg
                        class="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
                <form
                  @submit.prevent="changepassword"
                  class="px-6 py-5 space-y-4"
                >
                  <div class="mb-4">
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >Old Password <span class="text-red-400">*</span></label
                    >

                    <div class="flex items-center relative">
                      <input
                        type="password"
                        id="oldpassword"
                        class="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm pr-10 focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none"
                        placeholder="Enter old password"
                        required
                      />

                      <img
                        v-if="passwordType == 'oldpassword'"
                        src="@/assets/eyeslash.svg"
                        @click="hideShow('oldpassword')"
                        alt=""
                        class="cursor-pointer inline-block z-50 absolute bg-white right-4"
                      />
                      <img
                        v-else
                        src="@/assets/eye.svg"
                        @click="hideShow('oldpassword')"
                        alt=""
                        class="cursor-pointer inline-block z-50 absolute bg-white right-4"
                      />
                    </div>
                  </div>
                  <div class="mb-4">
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >New Password <span class="text-red-400">*</span></label
                    >

                    <div class="flex items-center relative">
                      <input
                        type="password"
                        id="oldtoNew"
                        class="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm pr-10 focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none"
                        placeholder="Enter new password"
                        required
                      />

                      <img
                        v-if="passwordType == 'oldtoNew'"
                        src="@/assets/eyeslash.svg"
                        @click="hideShow('oldtoNew')"
                        alt=""
                        class="cursor-pointer inline-block z-50 absolute bg-white right-4"
                      />
                      <img
                        v-else
                        src="@/assets/eye.svg"
                        @click="hideShow('oldtoNew')"
                        alt=""
                        class="cursor-pointer inline-block z-50 absolute bg-white right-4"
                      />
                    </div>
                  </div>

                  <div class="mb-4">
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >New Confirm Password
                      <span class="text-red-400">*</span></label
                    >

                    <div class="flex items-center relative">
                      <input
                        type="password"
                        id="changeconfirm"
                        class="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm pr-10 focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none"
                        placeholder="Confirm new password"
                        required
                      />

                      <img
                        v-if="passwordType == 'changeconfirm'"
                        src="@/assets/eyeslash.svg"
                        @click="hideShow('changeconfirm')"
                        alt=""
                        class="cursor-pointer inline-block z-50 absolute bg-white right-4"
                      />
                      <img
                        v-else
                        src="@/assets/eye.svg"
                        @click="hideShow('changeconfirm')"
                        alt=""
                        class="cursor-pointer inline-block z-50 absolute bg-white right-4"
                      />
                    </div>
                  </div>

                  <div class="flex justify-center pt-5">
                    <button
                      type="submit"
                      class="w-full px-6 py-2.5 bg-blues text-white text-sm font-medium rounded-lg hover:bg-hover shadow-md hover:shadow-lg transition-all"
                    >
                      Update Password
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <!-- Your content here -->
          <div
            id="image_uploads"
            class="bg-white rounded-lg shadow-sm w-[350px] outline-none"
          >
            <!-- Preview Modal -->
            <div
              v-if="showPreviewModal && previewItem"
              class="fixed inset-0 z-50 flex items-center justify-center p-4"
            >
              <div
                class="fixed inset-0 bg-black/60"
                @click="closePreviewModal"
              ></div>
              <div
                class="relative bg-white rounded-2xl shadow-2xl w-full max-w-3xl z-10 overflow-hidden"
              >
                <!-- Header -->
                <div
                  class="px-6 py-4 border-b border-gray-100 flex justify-between items-center bg-gray-50"
                >
                  <div>
                    <h3 class="text-base font-bold text-gray-900 capitalize">
                      {{ previewItem.code.replace(/_/g, " ").toLowerCase() }}
                    </h3>
                    <p class="text-xs text-gray-400 mt-0.5">
                      Email Template Preview
                    </p>
                  </div>
                  <button
                    @click="closePreviewModal"
                    class="p-2 hover:bg-gray-200 rounded-full transition-colors"
                  >
                    <svg
                      class="w-5 h-5 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>

                <!-- Body -->
                <div class="p-6 max-h-[100vh] overflow-y-auto">
                  <!-- VIEW MODE -->
                  <div v-if="!isEditingTemplate">
                    <!-- Has HTML content -->
                    <div
                      v-if="
                        previewItem.name &&
                        previewItem.name.trim().startsWith('<')
                      "
                      class="bg-white border border-gray-200 rounded-xl p-6 text-sm text-gray-800 leading-relaxed shadow-sm"
                      v-html="previewItem.name"
                    ></div>

                    <!-- No HTML template yet -->
                  </div>

                  <!-- EDIT MODE -->
                  <div v-else>
                    <label
                      class="block text-xs font-bold text-gray-400 uppercase tracking-widest mb-2"
                    >
                      Edit Email Template
                    </label>

                    <!-- Warning -->
                    <div
                      v-if="templateWarning"
                      class="mb-3 flex items-start gap-2.5 px-4 py-3 bg-amber-50"
                    >
                      <div v-if="templateWarning">
                        <p class="text-xs text-amber-700">
                          <span class="font-semibold text-sm">Example</span>
                          <span> &nbsp; Keep &nbsp; </span>
                          <span class="font-bold">{{ templateWarning }}</span>
                          — removing it will break the email.
                        </p>
                      </div>
                    </div>

                    <!-- Textarea -->
                    <textarea
                      v-model="editedTemplate"
                      @input="checkTemplatePlaceholders"
                      rows="14"
                      class="w-full border rounded-xl px-4 py-3 text-sm focus:ring-2 focus:outline-none resize-y font-mono transition-all"
                      :class="
                        templateWarning
                          ? 'border-amber-400 focus:ring-amber-300/30 focus:border-amber-400'
                          : 'border-blue-300 focus:ring-blue-500/20 focus:border-blue-500'
                      "
                      placeholder="Enter HTML email template..."
                    ></textarea>
                  </div>
                </div>

                <!-- Footer -->
                <div
                  class="px-6 py-4 bg-gray-50 border-t border-gray-100 flex justify-between items-center"
                >
                  <!-- Left: Edit / Cancel -->
                  <div>
                    <button
                      v-if="!isEditingTemplate"
                      @click="startEditTemplate"
                      class="flex items-center gap-2 px-5 py-2 bg-blues hover:bg-hover text-white text-sm font-bold rounded-lg transition-all"
                    >
                      <svg
                        class="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                        />
                      </svg>
                      Edit
                    </button>
                    <button
                      v-else
                      @click="isEditingTemplate = false"
                      class="px-5 py-2 bg-gray-200 hover:bg-gray-300 text-gray-700 text-sm font-bold rounded-lg transition-all"
                    >
                      Cancel
                    </button>
                  </div>

                  <!-- Right: Update / Close -->
                  <div class="flex gap-3">
                    <!-- <button
                @click="closePreviewModal"
                class="px-5 py-2 bg-white border border-gray-300 text-gray-700 text-sm font-bold rounded-lg hover:bg-gray-50 transition-all"
              >
                Close
              </button> -->
                    <button
                      v-if="isEditingTemplate"
                      @click="updateTemplate"
                      class="px-5 py-2 bg-blues hover:bg-hover text-white text-sm font-bold rounded-lg transition-all"
                    >
                      Update
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import axios from "axios";
import FlashMessage from "@/components/FlashMessage.vue";
import { mapGetters, mapMutations } from "vuex";
import Header from "@/components/Admin/Header.vue";
import Pagination from "@/components/Pagination.vue";
import { faLaugh } from "@fortawesome/free-regular-svg-icons";
import Footer from "@/components/Footer.vue";

export default {
  data() {
    return {
      templateWarning: "",
      mylist_searching: "",
      mylist_pageSize: 10,
      searching: "",
      isEditingTemplate: false,
      editedTemplate: "",
      showPreviewModal: false,
      previewItem: null,
      pageSize: 10,
      showToggleConfirm: false,
      pendingToggleItem: null,
      mylist_data: [],
      mylist_count: "",
      mylist_totalPages: 1,
      mylist_current_page: 1,
      profileInfo: null,
      popUp: false,
      updateDetails: null,
      stateList: [],
      cityList: [],
      selectedFile: null,
      tnxDetails: "",
      profile: false,
      messages: {
        text: "",
        type: "null",
      },
      selectedcontent: "Courses",
      courseDetails: null,
      boughtcourse: null,
      changePassword: false,
      passwordType: "password",
      activeMenu: "course",
      studentList: [],
      tabs: [
        "profile details",
        "accessible course",
        "meeting settings",
      //   "Automation",
      ],
      active_tab: "profile details",
      course_list: [],
      totalPages: 1,
      current_page: 1,
      course_count: null,
      loading: true,
      selectedInstructors: [],
      changeProfile: false,

      // new
      showCreateModal: false,
      selectedProvider: "Teams",
      // isActive: true,
      isEditing: false,
      newMeeting: {
        title: "",
        access_key: "",
        secret_key: "",
        zoom_client_id: "",
        zoom_client_secret: "",
        zoom_account_id: "",
        teams_published: false,
        zoom_published: false,
      },
      providers: [],
      selectedProvider: null,
      showDeleteModal: false,
    };
  },

  components: {
    Header,
    FlashMessage,
    Pagination,
    Footer,
  },
  mounted() {
    if (this.$route.query.tab === "meeting-settings") {
      this.active_tab = "meeting settings";
    }
  },

  computed: {
    ...mapGetters(["userInfo"]),
    selectedProviderData() {
      return this.providers.find((p) => p.title === this.selectedProvider);
    },
    isActive() {
      return this.selectedProviderData?.active ?? false;
    },
  },

  async created() {
    await this.openProcess();
    await this.getCourses(1);
    await this.getmeeting();
    this.loading = false;
    // let tempvar_courselist = [];
    // await axios
    //   .get(`${process.env.VUE_APP_API}/courses/?format=json`)
    //   .then((response) => (this.courseDetails = response.data.data));

    // this.courseDetails = this.courseDetails.filter((course) => {
    //   if (tempvar_courselist.includes(course.id)) {
    //     return course;
    //   }
    // });

    // this.getstudentdetails();
  },

  methods: {
      validateImage(event) {
      const file = event.target.files[0];
      if (!file) return;

      const allowedTypes = ["image/jpeg", "image/png"];

      if (!allowedTypes.includes(file.type)) {
        alert("Only JPG, JPEG, and PNG files are allowed.");
        event.target.value = "";
        return;
      }

      console.log(file);
    },
    clearMylistSearch() {
      this.mylist_searching = "";
      this.mylist(1);
    },

    clearMylistFilters() {
      this.mylist_searching = "";
      this.mylist(1);
    },
    onMylistPageSizeChange() {
      this.mylist_current_page = 1;
      this.mylist(1);
    },
    onPageSizeChange() {
      this.current_page = 1;
      if (this.$refs.paginationRef) {
        this.$refs.paginationRef.current_page = 1;
      }
      this.getCourses(1);
    },
    clearSearch() {
      this.searching = "";
      if (this.$refs.paginationRef) {
        this.$refs.paginationRef.current_page = 1;
      }
      this.getCourses(1);
    },

    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "numeric",
        year: "numeric",
      });
    },
    async handleTabClick(tab) {
      this.active_tab = tab;
      if (tab === "Automation") {
        await this.mylist();
      }
    },
    openPreviewModal(item) {
      this.previewItem = item;
      this.showPreviewModal = true;
    },
    closePreviewModal() {
      this.showPreviewModal = false;
      this.previewItem = null;
    },

    async mylist(page = 1) {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/trigger-push/list/?page=${page}&page_size=${this.mylist_pageSize}&Key=${this.userInfo.token_key}&search=${this.mylist_searching}`,
        );
        if (response.data.data && response.data.data.status == 200) {
          this.mylist_data = response.data.data.data;
          this.mylist_totalPages = response.data.total_page; // ← from API
          this.mylist_current_page = response.data.current_page; // ← from API
          this.mylist_count = response.data.total; // ← from API
        } else {
          this.mylist_data = [];
          this.mylist_count = 0;
        }
      } catch (err) {
        console.log("mylist error:", err);
        this.mylist_data = [];
        this.mylist_count = 0;
      }
    },

    async togglePush(item) {
      try {
        const res = await axios.put(
          `${process.env.VUE_APP_API}/trigger-push/edit/${item.slug}/?Key=${this.userInfo.token_key}`,
          { push_enabled: !item.push_enabled },
        );
        if (res.data.status === 200) {
          item.push_enabled = !item.push_enabled;
          await this.mylist(this.mylist_current_page); // ← keep current page
          this.messages = {
            text: res.data.message || "Updated successfully",
            type: "success",
          };
        } else {
          this.messages = {
            text: res.data.message || "Update failed",
            type: "error",
          };
        }
      } catch (err) {
        console.error("Toggle error:", err);
        this.messages = { text: "Update failed", type: "error" };
      }
      setTimeout(() => {
        this.messages = { text: "", type: "null" };
      }, 1500);
    },
    askToggleConfirm(item) {
      this.pendingToggleItem = item;
      this.showToggleConfirm = true;
    },

    cancelToggle() {
      this.showToggleConfirm = false;
      this.pendingToggleItem = null;
    },
    async confirmToggle() {
      this.showToggleConfirm = false;
      if (this.pendingToggleItem) {
        await this.togglePush(this.pendingToggleItem);
        this.pendingToggleItem = null;
      }
    },
    async toggleActive() {
      if (!this.selectedProviderData) return;
      try {
        const slug = this.selectedProviderData.slug;
        const res = await axios.put(
          `${process.env.VUE_APP_API}/user-meettings-active/update/${slug}/?Key=${this.userInfo.token_key}`,
          {
            user: this.userInfo.user.id,
            active: !this.selectedProviderData.active,
          },
        );
        if (res.data.status === 200) {
          this.messages = { text: res.data.message, type: "success" };
          setTimeout(() => {
            this.messages = { text: "", type: "null" };
            this.getmeeting();
          }, 1500);
        } else {
          this.messages = { text: "Event Failed", type: "error" };
          setTimeout(() => {
            this.messages = { text: "", type: "null" };
          }, 1500);
        }
      } catch (err) {
        console.error("Failed to toggle status", err);
      }
    },

    async getmeeting() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/user-meetings-keys/get/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.providers = response.data.data;
            if (!this.selectedProvider && this.providers.length > 0) {
              this.selectedProvider = this.providers[0].title;
            }
          } else if (response.data.status == 400) {
            this.providers = [];
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },

    async saveSettings() {
      if (!this.selectedProviderData) return;
      let value = {};
      if (this.selectedProviderData.title === "Teams") {
        value = {
          access_key: this.selectedProviderData.value.access_key,
          secret_key: this.selectedProviderData.value.secret_key,
        };
      }
      if (this.selectedProviderData.title === "Zoom") {
        value = {
          zoom_client_id: this.selectedProviderData.value.zoom_client_id,
          zoom_client_secret:
            this.selectedProviderData.value.zoom_client_secret,
          zoom_account_id: this.selectedProviderData.value.zoom_account_id,
        };
      }
      const payload = {
        title: this.selectedProviderData.title,
        value: value,
        user: this.userInfo.user.id,
      };
      const currentProvider = this.selectedProvider;
      try {
        const slug = this.selectedProviderData.slug;
        const res = await axios.put(
          `${process.env.VUE_APP_API}/user-meetings-key/update/${slug}/?Key=${this.userInfo.token_key}`,
          payload,
        );
        if (res.data.status === 200 || res.data.success) {
          this.isEditing = false;
          this.messages = { text: res.data.message, type: "success" };
          setTimeout(() => {
            this.messages = { text: "", type: "null" };
            this.getmeeting();
            this.selectedProvider = currentProvider;
          }, 1500);
        } else {
          this.messages = { text: "Event Failed", type: "error" };
          setTimeout(() => {
            this.messages = { text: "", type: "null" };
          }, 1500);
        }
      } catch (err) {
        console.error("Update error:", err);
        this.messages = { text: "Update failed", type: "error" };
      }
    },

    async confirmDelete() {
      if (!this.selectedProviderData) return;
      try {
        const slug = this.selectedProviderData.slug;
        const res = await axios.delete(
          `${process.env.VUE_APP_API}/user-meetings-key/update/${slug}/?Key=${this.userInfo.token_key}`,
        );
        if (res.data.status === 200 || res.data.success) {
          this.providers = this.providers.filter((p) => p.slug !== slug);
          this.selectedProvider =
            this.providers.length > 0 ? this.providers[0].title : null;
          this.showDeleteModal = false;
          this.isEditing = false;
          this.messages = { text: res.data.message, type: "success" };
          setTimeout(() => {
            this.messages = { text: "", type: "null" };
            this.getmeeting();
          }, 1500);
        } else {
          this.messages = { text: "Event Failed", type: "error" };
          setTimeout(() => {
            this.messages = { text: "", type: "null" };
          }, 1500);
        }
      } catch (err) {
        console.error("Update error:", err);
      }
    },

    async submitMeeting() {
      let value = {};
      let active = false;
      if (this.newMeeting.title === "Teams") {
        value = {
          access_key: this.newMeeting.access_key,
          secret_key: this.newMeeting.secret_key,
        };
        active = this.newMeeting.teams_published;
      }
      if (this.newMeeting.title === "Zoom") {
        value = {
          zoom_client_id: this.newMeeting.zoom_client_id,
          zoom_client_secret: this.newMeeting.zoom_client_secret,
          zoom_account_id: this.newMeeting.zoom_account_id,
        };
        active = this.newMeeting.zoom_published;
      }
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API}/user-meetings-keys/create/?Key=${this.userInfo.token_key}`,
          {
            title: this.newMeeting.title,
            value: value,
            user: this.userInfo.user.id,
            active: active,
          },
        );
        if (response.data.status === 200) {
          this.messages = { text: response.data.message, type: "success" };
          this.showCreateModal = false;
          this.getmeeting();
        } else {
          this.messages = {
            text: response.data.message || "Event Failed",
            type: "error",
          };
        }
      } catch (error) {
        this.messages = {
          text:
            error.response?.data?.message ||
            `${this.newMeeting.title} already created`,
          type: "error",
        };
      }
      setTimeout(() => {
        this.messages = { text: "", type: "null" };
        this.newMeeting = {
          title: "",
          access_key: "",
          secret_key: "",
          zoom_client_id: "",
          zoom_client_secret: "",
          zoom_account_id: "",
          teams_published: false,
          zoom_published: false,
        };
      }, 1500);
    },

    ...mapMutations(["updateImage"]),

    hideShow(id) {
      const passwordField = document.querySelector(`#${id}`);
      passwordField.getAttribute("type") === "password"
        ? passwordField.setAttribute("type", "text")
        : passwordField.setAttribute("type", "password");
      this.passwordType = this.passwordType == id ? "password" : id;
    },

    ChangePasswordPopup() {
      this.changePassword = true;
    },

    async changepassword() {
      let oldpassWord = document.querySelector("#oldpassword").value;
      let newpassword = document.querySelector("#oldtoNew").value;
      let confirmpassword = document.querySelector("#changeconfirm").value;
      if (newpassword == confirmpassword) {
        var responseMail;
        await axios
          .post(`${process.env.VUE_APP_API}/login`, {
            username: this.userInfo.user.email,
            password: oldpassWord,
          })
          .then((response) => {
            responseMail = response.data.user
              ? response.data.user.email
              : "error";
          });
        if (responseMail == this.userInfo.user.email) {
          await axios
            .put(
              `${process.env.VUE_APP_API}/api/change-password/?Key=${this.userInfo.token_key}`,
              {
                old_password: oldpassWord,
                new_password: confirmpassword,
              },
            )
            .then((response) => {
              this.messages =
                response.data.message == "Password updated successfully"
                  ? { text: "Password updated successfully", type: "success" }
                  : { text: "Event Failed", type: "error" };
            });
          document.querySelector("#oldpassword").value = "";
          document.querySelector("#oldtoNew").value = "";
          document.querySelector("#changeconfirm").value = "";
          this.changePassword = false;
          setTimeout(() => {
            this.messages = { text: "", type: "" };
          }, 3000);
        } else {
          this.errorMessage = {
            text: "Old Password Not Matching",
            type: "error",
          };
          setTimeout(() => {
            this.errorMessage = { text: "", type: "" };
          }, 1500);
        }
      } else {
        this.errorMessage = {
          text: "Confirm Password Miss Match",
          type: "error",
        };
        setTimeout(() => {
          this.errorMessage = { text: "", type: "" };
        }, 1500);
      }
    },

    async imageHandles() {
      this.profile = false;
      let headerprofile = new FormData();
      headerprofile.append("id", this.userInfo.user.id);
      headerprofile.append(
        "profile",
        document.querySelector("#image_uploads").files[0],
      );
      await axios
        .put(
          `${process.env.VUE_APP_API}/upload_photo/?Key=${this.userInfo.token_key}`,
          headerprofile,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: "Profile Uploaded successfully",
              type: "success",
            };
            this.openProcess();
            this.updateImage(`${response.data.data.profile}`);
          } else {
            this.messages = { text: "Event Failed", type: "error" };
          }
        })
        .catch((error) => {
          this.messages = { text: error.response.data.error, type: "error" };
        });
      setTimeout(() => {
        this.messages = { text: "", type: "null" };
        this.changeProfile = false;
      }, 3000);
    },

    async openProcess() {
      axios
        .get(
          `${process.env.VUE_APP_API}/paymentlist/?Key=${this.userInfo.token_key}`,
        )
        .then((res) => {
          this.tnxDetails = res.data;
        });
      await axios
        .get(
          `${process.env.VUE_APP_API}/profile_detail/?Key=${this.userInfo.token_key}&format=json`,
        )
        .then((response) => (this.profileInfo = response.data));
    },

    cleanValue(value) {
      return value && value !== "None" ? value : "";
    },

    withCurrent(list, current) {
      return current && !list.includes(current) ? [current, ...list] : list;
    },

    async getStatesAndCities() {
      const key = this.userInfo.token_key;
      try {
        const [states, cities] = await Promise.all([
          axios.get(`${process.env.VUE_APP_API}/profile-state/?Key=${key}`),
          axios.get(`${process.env.VUE_APP_API}/profile-city/?Key=${key}`),
        ]);
        this.stateList = (states.data.data || []).map((x) => x.state);
        this.cityList = (cities.data.data || []).map((x) => x.city);
      } catch (err) {
        console.error("Error fetching states/cities:", err);
      }
    },

    async ProfileEdit() {
      let details_id = this.profileInfo.data.id;
      this.popUp = true;
      this.getStatesAndCities();
      await axios
        .get(
          `${process.env.VUE_APP_API}/profile_update/${details_id}?Key=${this.userInfo.token_key}&format=json`,
        )
        .then((response) => {
          this.updateDetails = {
            ...response.data.data,
            state: this.cleanValue(this.profileInfo.data.state),
            city: this.cleanValue(this.profileInfo.data.city),
          };
        });
    },

    async SubmitProfile() {
      let details_id = this.profileInfo.data.id;
      let update = this.updateDetails;
      this.popUp = false;
      await axios
        .put(
          `${process.env.VUE_APP_API}/profile_update/${details_id}/?Key=${this.userInfo.token_key}&format=json`,
          update,
        )
        .then((response) => {
          this.messages =
            response.data.message == "Profile updated successfully"
              ? { text: "Profile Uploaded successfully", type: "success" }
              : { text: "Event Failed", type: "error" };
        });
      setTimeout(() => {
        this.messages = { text: "", type: "null" };
        this.openProcess();
      }, 3000);
    },

    async getCourses(page) {
      this.current_page = page;
      await axios
        .get(
          `${process.env.VUE_APP_API}/courses/?page=${page}&page_size=${this.pageSize}&Key=${this.userInfo.token_key}&search=${this.searching}`,
        )
        .then((res) => {
          if (res.data.data.data.status == 200) {
            this.totalPages = res.data.data.total_page;
            this.current_page = res.data.data.current_page;
            this.course_list = res.data.data.data.data;
            this.selectedInstructors = this.course_list;
            this.course_count = res.data.data.total;
          } else {
            this.course_count = 0;
            this.course_list = [];
          }
        })
        .catch((err) => {
          console.log("error", err);
          this.course_list = [];
          this.course_count = 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    startEditTemplate() {
      this.editedTemplate = this.previewItem.name;
      this.templateWarning = "";
      this.isEditingTemplate = true;
    },

    closePreviewModal() {
      this.showPreviewModal = false;
      this.previewItem = null;
      this.isEditingTemplate = false;
      this.editedTemplate = "";
      this.templateWarning = "";
    },

    checkTemplatePlaceholders() {
      const originalVars = [
        ...this.previewItem.name.matchAll(/\{\{[^}]+\}\}/g),
      ].map((m) => m[0].trim());
      const missing = originalVars.filter(
        (v) => !this.editedTemplate.includes(v),
      );
      this.templateWarning = missing.length > 0 ? missing.join(", ") : "";
    },

    async updateTemplate() {
      if (this.templateWarning) {
        this.messages = {
          text: "Please restore all placeholder variables before saving.",
          type: "error",
        };
        setTimeout(() => {
          this.messages = { text: "", type: "null" };
        }, 2500);
        return;
      }
      try {
        const res = await axios.put(
          `${process.env.VUE_APP_API}/trigger-push/content/edit/${this.previewItem.slug}/?Key=${this.userInfo.token_key}`,
          { name: this.editedTemplate },
        );
        if (res.data.status === 200) {
          this.previewItem.name = this.editedTemplate;
          this.isEditingTemplate = false;
          this.templateWarning = "";
          this.messages = {
            text: res.data.message || "Updated successfully",
            type: "success",
          };
          await this.mylist(this.mylist_current_page);
        } else {
          this.messages = {
            text: res.data.message || "Update failed",
            type: "error",
          };
        }
      } catch (err) {
        this.messages = { text: "Update failed", type: "error" };
      }
      setTimeout(() => {
        this.messages = { text: "", type: "null" };
      }, 1500);
    },
  },
};
</script>

<style scoped></style>
